
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById("template--21309852025048__c_product_v2");
    if (!root || typeof Swiper === 'undefined') return;

    var thumbs = new Swiper(root.querySelector('.c-pv2__thumbs-slider'), {
      spaceBetween: 8,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true
    });

    new Swiper(root.querySelector('.c-pv2__main-slider'), {
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: root.querySelector('.c-pv2__main-pagination'),
        clickable: true
      },
      navigation: {
        prevEl: root.querySelector('.c-pv2__main-prev'),
        nextEl: root.querySelector('.c-pv2__main-next')
      },
      thumbs: { swiper: thumbs }
    });

    var reviewsEl = root.querySelector('.c-pv2__reviews-slider');
    if (reviewsEl) {
      new Swiper(reviewsEl, {
        spaceBetween: 16,
        slidesPerView: 1,
        autoHeight: true,
        pagination: {
          el: root.querySelector('.c-pv2__reviews-pagination'),
          clickable: true
        },
        navigation: {
          prevEl: root.querySelector('.c-pv2__reviews-prev'),
          nextEl: root.querySelector('.c-pv2__reviews-next')
        }
      });
    }

    // FAQ accordion (toggle .is-open)
    root.querySelectorAll('.c-pv2__faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.c-pv2__faq-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Código de referido: click copia al portapapeles y muestra el feedback 2s
    var codeBtn = root.querySelector('.c-pv2__referral-code[data-pv2-code]');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-pv2-code') || '';
        var done = function () {
          var original = code;
          codeBtn.textContent = codeBtn.getAttribute('data-pv2-copied') || 'Copied!';
          codeBtn.classList.add('is-copied');
          setTimeout(function () {
            codeBtn.textContent = original;
            codeBtn.classList.remove('is-copied');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {});
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = code;
          tmp.setAttribute('readonly', '');
          tmp.style.position = 'absolute';
          tmp.style.left = '-9999px';
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(tmp);
        }
      });
    }
  });


  (function () {
    var SELECTOR = '[data-sl-id="c-accordion-over-image"]';

    function setItem(item, open) {
      var trigger = item.querySelector('.c-aoi__trigger');
      item.classList.toggle('c-aoi__item--open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function init(root) {
      if (!root || root.getAttribute('data-aoi-ready') === 'true') return;
      root.setAttribute('data-aoi-ready', 'true');

      root.addEventListener('click', function (event) {
        var trigger = event.target.closest('.c-aoi__trigger');
        if (!trigger || !root.contains(trigger)) return;

        var item = trigger.closest('.c-aoi__item');
        var wasOpen = item.classList.contains('c-aoi__item--open');

        root.querySelectorAll('.c-aoi__item').forEach(function (el) {
          setItem(el, false);
        });
        if (!wasOpen) setItem(item, true);
      });
    }

    init(document.getElementById('template--21309852025048__c_accordion_over_image_bf'));

    if (!window.slAoiEditorBound) {
      window.slAoiEditorBound = true;

      document.addEventListener('shopify:section:load', function () {
        document.querySelectorAll(SELECTOR).forEach(init);
      });

      document.addEventListener('shopify:block:select', function (event) {
        var item = event.target;
        if (!item || !item.classList || !item.classList.contains('c-aoi__item')) return;
        var root = item.closest(SELECTOR);
        if (!root) return;
        root.querySelectorAll('.c-aoi__item').forEach(function (el) {
          setItem(el, el === item);
        });
      });
    }
  })();


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#template--21309852025048__c_testimonials_v2_JaUcLr .c-tv2-native-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var video = this.previousElementSibling;
        this.style.display = 'none';
        if (video && video.tagName === 'VIDEO') video.play();
      });
    });

    document.querySelectorAll('#template--21309852025048__c_testimonials_v2_JaUcLr .c-tv2-video-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var type = this.dataset.videoType;
        var id   = this.dataset.videoId;
        var src  = '';

        if (type === 'youtube') {
          src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        } else if (type === 'vimeo') {
          src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        }

        if (!src) return;

        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.className = 'c-tv2-embed';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        this.replaceWith(iframe);
      });
    });

    var section = document.getElementById('template--21309852025048__c_testimonials_v2_JaUcLr');
    var carousel = section && section.querySelector('.c-tv2-carousel.swiper');
    if (carousel && typeof Swiper !== 'undefined') {
      new Swiper(carousel, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 12,
        watchOverflow: true,
        breakpoints: {
          769: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12
          }
        },
        navigation: {
          nextEl: '#template--21309852025048__c_testimonials_v2_JaUcLr .c-tv2-nav-next',
          prevEl: '#template--21309852025048__c_testimonials_v2_JaUcLr .c-tv2-nav-prev',
          disabledClass: 'swiper-button-disabled'
        }
      });
    }
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#template--21309852025048__c_how_to_steps .c-hts__card-facade').forEach(function (facade) {
      facade.addEventListener('click', function () {
        var video = this.previousElementSibling;
        this.style.display = 'none';
        if (video && video.tagName === 'VIDEO') video.play();
      });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    var section = document.getElementById('template--21309852025048__c_testimonials_no_img');
    if (!section || typeof Swiper === 'undefined') return;
    var el = section.querySelector('.c-tni__swiper');
    if (!el) return;

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      navigation: {
        prevEl: section.querySelector('.c-tni__prev'),
        nextEl: section.querySelector('.c-tni__next')
      },
      pagination: {
        el: section.querySelector('.c-tni__pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          spaceBetween: 16
        }
      }
    });
  });


  (function () {
    var section = document.getElementById('template--21309852025048__c_collapsible_info');
    if (!section) return;

    section.querySelectorAll('.c-ci__item-header').forEach(function (header) {
      header.addEventListener('click', function () {
        var item = header.closest('.c-ci__item');
        var isOpen = item.classList.contains('c-ci__item--open');

        section.querySelectorAll('.c-ci__item').forEach(function (el) {
          el.classList.remove('c-ci__item--open');
        });

        if (!isOpen) {
          item.classList.add('c-ci__item--open');
        }
      });
    });
  })();


  (function () {
    var section = document.getElementById('template--21309852025048__c_faqs_v2_kDzaUM');
    if (!section) return;

    section.querySelectorAll('.c-fv2-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.c-fv2-item');
        var isOpen = item.classList.contains('is-open');

        section.querySelectorAll('.c-fv2-item').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.c-fv2-question').setAttribute('aria-expanded', 'false');
          el.querySelector('.c-fv2-answer').setAttribute('aria-hidden', 'true');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          item.querySelector('.c-fv2-answer').setAttribute('aria-hidden', 'false');
        }
      });
    });
  })();

